export default {
  light: {
    primary: "#1cb1eb",
    primaryConst: "#536dfe",
    secondary: "#FF5C93",
    secondaryConst: "#FF5C93",
    error: "#FF4081",
    errorDark: '#893130',
    warning: "#FFC260",
    success: "#3CD4A0",
    successConst: "#3CD4A0",
    info: "#9013FE",
    greyBold: '#4a4a4a',
    greyBoldConst: '#4a4a4a',
    greyMedium: '#6e6e6e',
    greyTint: '#b9b9b9',
    greyDark: '#525252',
    default: '#e0e0e0',
    iconColor: "#FFFFFF", //previously #FFFFFF59 but vuetify does not support rgba,
    scaleRed: '#df5e63',
    scaleOrange: '#df8b5d',
    scaleYellow: '#dfd95e',
    scaleGreen: '#13be9c',
    scaleDefault: '#5e64df',

    /**
     * Colors for task list status
     */
    // color for an invitation
    "task-list--role-invitation": '#df8b5d',
    "task-list--job-invitation": '#df8b5d',

    // colors for failed and successful process results
    "task-list--result-success": '#13be9c',
    "task-list--result-failed": '#df5e63',

    // colors for jobs
    "task-list--job-open-valid": '#9E9E9E',
    "task-list--job-open-invalid": '#893130',
    "task-list--job-accepted-valid": '#5eb0df',
    "task-list--job-accepted-invalid": '#893130',
    "task-list--job-accepted-future": '#4a4a4a',
    "task-list--job-not-accepted-future": '#4a4a4a'
  },
  dark: {
    primary: "#536dfe",
    primaryConst: "#536dfe",
    secondary: "#FF5C93",
    secondaryConst: "#FF5C93",
    success: "#3CD4A0",
    successConst: "#3CD4A0",
    error: "#FF4081",
    greyMedium: '#bfbfbf',
    greyBold: '#d6d6d6',
    greyBoldConst: '#4a4a4a',
    greyTint: '#9b9b9b',
    default: '#e0e0e0',
  },
  auth: {
    email: 'admin@flatlogic.com',
    password: 'password'
  }
};


